import { useMutation } from "@tanstack/react-query";
import { updateEmail } from "../services/users.service";

export const useUpdateEmail = () => {
  return useMutation({
    mutationFn: updateEmail,
  });
};
